// extracted by mini-css-extract-plugin
export default {"agreementText":"AgreementTextV4_agreementText-NcH"};